import { ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

export enum UserFriendlyDialogActionTypes {
    ON_CLOSE = "ERROR_DIALOG/ON_CLOSE",
}

export const doCloseUserFriendlyDialog: ActionCreator<ThunkAction<any, any, any, any>> =
    (reInitAppFunc: Function) => dispatch => {
        dispatch(doCloseDialogAction());
        if (reInitAppFunc) {
            reInitAppFunc();
        }
    };

type CloseDialogAction = {
    type: UserFriendlyDialogActionTypes.ON_CLOSE;
};
export const doCloseDialogAction: ActionCreator<CloseDialogAction> = () => ({
    type: UserFriendlyDialogActionTypes.ON_CLOSE,
});
